import {v4 as uuidv4} from 'uuid';
import {vFormControls} from '@/enum';

export const createNextButton = () => ({
  formElementTypeString: vFormControls.BUTTON,
  formElementType: vFormControls.BUTTON,
  showAsTiles: false,
  uuid: uuidv4(),
  bottomDropZone: true,
  alignment: 'right',
  label: {dix: {Unknown: ''}, imageDix: {Unknown: ''}},
  expanded: true
});

// Repair generated placeholder IDs in memory. Stored content changes only on an explicit save.
export const ensureUniqueNextButtonIds = steps => {
  const usedIds = new Set();
  for (const step of steps) {
    for (const element of step.elements || []) {
      if (!element.bottomDropZone && element.uuid) usedIds.add(element.uuid);
    }
  }

  let repaired = 0;
  for (const step of steps) {
    for (const element of step.elements || []) {
      if (element.formElementTypeString !== vFormControls.BUTTON || !element.bottomDropZone) continue;
      if (!element.uuid || usedIds.has(element.uuid)) {
        do { element.uuid = uuidv4(); } while (usedIds.has(element.uuid));
        repaired++;
      }
      usedIds.add(element.uuid);
    }
  }
  return repaired;
};
